// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
export const getLoading = state => state.voucherConfirmedReducer.loading;
export const getBookshopCustomer = state => state.voucherConfirmedReducer.bookshopCustomer;
export const getValue = state => state.voucherConfirmedReducer.value;
export const getValueStatus = state => state.voucherConfirmedReducer.valueStatus;
export const getConfirmModal = state => state.voucherConfirmedReducer.isOpenConfirmModal;
